import React from 'react';
import './About.css'
import rabiul from '../../images/rabiul.jpg'

const About = () => {
    return (
        <div className=' pt-2 container'>
            <h1 className='text-primary mb-5'>About Us</h1>
            <div className='d-flex justify-content-between'>
<div>
<img className='img-fluid' src={rabiul}/>
</div>
<div>
<h5>This is Rabiul Hossen.I am learner,Hard-worker,dreamer and enthuasism jr Web developer.I am learning MERN Stack from my favourite Programming hero web course.MY mission is to Sr wev developer and goal is a multinational tech giant companty software engineer.</h5>
</div>


            </div>
            
        </div>
    );
};

export default About;